import { Card, Col, message, Modal, Row, Space, Tag, Tooltip, Typography } from "antd";
import { CustomGridTable } from "../../../blueplanitUtils/CustomGridTable";
import dayjs from "dayjs";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faFilter, faSync, faXmark } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { getCandidateListAsync, updateCandidateStatusAsync } from "../../../Slices/hiringSlice";
import { AntdButton, DatePickerField, InputField, SelectInput } from "../../../blueplanitUtils/InputField";
import AddCandidate from "./AddCandidate";
import { useNavigate, useParams } from "react-router-dom";
import CandidateDetails from "./CandidateDetails";
import { getOptionsByPath } from "../../../utilsdata";
import { ADD_EDIT_EMPLOYEE, EMPLOYEE_DEPARTMENT } from "../../../Dropdownmanager";
import { setLoader } from "../../../Slices/loaderSlice";

const { Text, Title } = Typography;

const statusColors = {
    Applied: "blue",
    Shortlisted: "cyan",
    Interview: "gold",
    Offer: "purple",
    Hired: "green",
    Rejected: "red",
    Hold: "orange",
    Selected: "lime",
};

const CandidateList = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [viewCandidate, setViewCandidate] = useState(null);
    const candidatesData = useSelector((state) => state.hiring.candidateList);
    console.log("Candidates Data:", candidatesData);
    const [prevVisibility, setDivVisibility] = useState(false);
    const [open, setOpen] = useState(false);
    const [status, setStatus] = useState("");
    const [jobTitle, setJobTitle] = useState("");
    const [source, setSource] = useState([]);
    const [department, setDepartment] = useState("");
    const [experienceFrom, setExperienceFrom] = useState("");
    const [experienceTo, setExperienceTo] = useState("");
    const [result, setResult] = useState("");
    const [RequisitionId, setRequisitionId] = useState("")


    const NestedDatabucket = useSelector((state) => state.dataBucket.NestedDatabucket);

    useEffect(() => {
        const variables = {
            status: status || null,
            source: source || null,
            jobTitle: jobTitle || null,
            department: department || null,
        };
        dispatch(getCandidateListAsync(variables));
    }, [dispatch])


    const columns = [
        {
            title: "Candidate ID",
            dataIndex: "candidateId",
            key: "candidateId",
            width: 100,
            render: (text) => <strong>{text}</strong>,
        },
        {
            title: "Requisition ID",
            dataIndex: "requisitionId",
            key: "requisitionId"
        },
        {
            title: "Name",
            key: "name",
            render: (_, row) => {
                const fullName = `${row?.firstName} ${row?.lastName || ""}`;
                return (
                    <span>
                        {fullName}
                    </span>

                );
            }
        },
        {
            title: "Email",
            dataIndex: "email",
            key: "email"
        },
        {
            title: "Job Applied",
            dataIndex: "jobTitle",
            key: "jobTitle"
        },
        {
            title: "Experience",
            dataIndex: "experience",
            key: "experience"
        },
        {
            title: "Current CTC",
            dataIndex: "currentCTC",
            key: "currentCTC",
            width: 100,
        },
        {
            title: "Expected CTC",
            dataIndex: "expectedCTC",
            key: "expectedCTC",
            width: 100,
        },
        {
            title: "Source",
            dataIndex: "source",
            key: "source",
            render: (source) => <Tag>{source}</Tag>,
            width: 100,
        },
        {
            title: "Status",
            dataIndex: "approvalStatus",
            key: "approvalStatus",
            width: 150,
            render: (status) => (
                <Tag
                    color={statusColors[status] || "default"}
                    style={{ fontWeight: 600, borderRadius: 6, padding: "4px 10px" }}
                >
                    {status}
                </Tag>
            ),
        },
        {
            title: "Applied On",
            dataIndex: "createdAt",
            key: "createdAt",
            width: 120,
            render: (date) => dayjs(parseInt(date)).format("DD/MM/YYYY"),
        },
         {
            title: "Created By",
            dataIndex: "createdBy",
            key: "createdBy",
            width: 120,
        }
    ];

    const handleFilters = () => {
        setDivVisibility((prevVisibility) => !prevVisibility);
    };

    const closeCard = () => {
        setDivVisibility(false);
    };

    const handleDetailPage = (record) => {
        navigate(`/CandidateList/${record}`)
    }
    const handleRowClick = (record) => {
        handleDetailPage(record.id)
        //setFormData(record);
    }

    const handleSearch = () => {
        const payload = {};

        if (status) payload.status = status;
        if (source && source.length > 0) payload.source = source;
        if (department) payload.department = department;
        if (jobTitle) payload.jobTitle = jobTitle;

        if (experienceFrom !== "") {
            payload.experienceFrom = parseFloat(experienceFrom);
        }

        if (experienceTo !== "") {
            payload.experienceTo = parseFloat(experienceTo);
        }
        if (result) payload.result = result;
        if(RequisitionId) payload.requisitionId = RequisitionId

        dispatch(getCandidateListAsync(payload));
    };

    const onClear = () => {
        setStatus(null);
        setSource([]);
        setDepartment(null);
        setJobTitle("");
        setExperienceFrom(null)
        setExperienceTo("")
        setResult("")
        setRequisitionId("")
        dispatch(getCandidateListAsync({}));
    };


    const handleSync = async () => {
        try {
            dispatch(setLoader(true));
            await dispatch(getCandidateListAsync({}));
        }
        catch (error) {
            console.error('Error refetching candidate details', error);
        } finally {
            dispatch(setLoader(false));
        }
    }

    return (
        <div className="page-wrapper">
            <div className="content container-fluid">
                {(id !== undefined) ? <CandidateDetails /> :
                    <>
                        {open && <AddCandidate setOpen={setOpen} />}
                        {!open && (
                            <div className="frame-container" style={{ marginTop: "20px" }}>
                                <div className={`left-frame ${prevVisibility ? "show" : "hide"}`} style={{ overflow: "scroll" }}>
                                    <AntdButton
                                        icon={<FontAwesomeIcon icon={faXmark} />}
                                        onClick={closeCard}
                                        shape="circle"
                                        className="card-close-btn"
                                    />
                                    <div style={{ margin: "9px", marginTop: "20px" }}>
                                        <div>
                                            <InputField
                                                label="Requisition ID"
                                                name="requisitionId"
                                                value={RequisitionId}
                                                onChange={(e) => setRequisitionId(e.target.value)}
                                            />
                                        </div>
                                        <div style={{ marginBottom: '-10px' }}>
                                            <SelectInput
                                                label="Status"
                                                name="status"
                                                allowClear
                                                placeholder="Select Status"
                                                style={{ width: "100%" }}
                                                options={[
                                                    { label: "Applied", value: "Applied" },
                                                    { label: "Shortlisted", value: "Shortlisted" },
                                                    { label: "Interview", value: "Interview" },
                                                    { label: "Offer", value: "Offer" },
                                                    { label: "Hired", value: "Hired" },
                                                    { label: "Rejected", value: "Rejected" },
                                                    { label: "Screening", value: "Screening" },
                                                    { label: "Technical Round", value: "Technical" },
                                                    { label: "HR Round", value: "HR" },
                                                    { label: "Manager Round", value: "Manager" },
                                                ]}
                                                value={status}
                                                onChange={(value) => setStatus(value)}
                                            />
                                        </div>

                                        <div style={{ marginBottom: '0px' }}>
                                            <InputField
                                                label="Role"
                                                name="jobTitle"
                                                placeholder="Search by applied role"
                                                value={jobTitle}
                                                onChange={(e) => setJobTitle(e.target.value)}
                                            />
                                        </div>

                                        <div style={{ marginBottom: '-10px' }}>
                                            <SelectInput
                                                label="Source"
                                                name="source"
                                                allowClear
                                                placeholder="Select Source"
                                                style={{ width: "100%" }}
                                                mode="multiple"
                                                options={[
                                                    { label: "LinkedIn", value: "LinkedIn" },
                                                    { label: "Indeed", value: "Indeed" },
                                                    { label: "Naukri", value: "Naukri" },
                                                    { label: "Referral", value: "Referral" },
                                                    { label: "Walk_In", value: "Walk_In" },
                                                    { label: "Website", value: "Website" }
                                                ]}
                                                value={source}
                                                onChange={(value) => setSource(value)}
                                            />
                                        </div>
                                        <div style={{ marginBottom: '-10px' }}>
                                            <SelectInput
                                                label="Department"
                                                name="department"
                                                allowClear
                                                placeholder="Select Department"
                                                style={{ width: "100%" }}
                                                value={department}
                                                options={[
                                                    { label: "Sales & Marketing", value: "Sales & Marketing" },
                                                    { label: "Insurance Operations", value: "Insurance Operations" },
                                                    { label: "HR & Admin", value: "HR & Admin" },
                                                    { label: "Information Technology", value: "Information Technology" },
                                                    { label: "Networking & Cyber Security", value: "Networking & Cyber Security" }
                                                ]}
                                                onChange={(value) => setDepartment(value)}
                                            />
                                        </div>

                                        <div style={{ marginBottom: '10px' }}>
                                            <InputField
                                                label="Experience From (Years)"
                                                name="experienceFrom"
                                                placeholder="Min experience"
                                                style={{ width: "100%" }}
                                                value={experienceFrom}
                                                onChange={(e) => setExperienceFrom(e.target.value)}
                                            />
                                        </div>

                                        <div style={{ marginBottom: '0px' }}>
                                            <InputField
                                                label="Experience To (Years)"
                                                name="experienceTo"
                                                placeholder="Max experience"
                                                style={{ width: "100%" }}
                                                value={experienceTo}
                                                onChange={(e) => setExperienceTo(e.target.value)}
                                            />
                                        </div>

                                        <div style={{ marginBottom: '-10px' }}>
                                            <SelectInput
                                                label="Shift Preference"
                                                name="shiftpreference"
                                                allowClear
                                                placeholder="Select Shift Preference"
                                                style={{ width: "100%" }}
                                                options={[
                                                    { label: "General", value: "General" },
                                                    { label: "Morning", value: "Morning" },
                                                    { label: "Evening", value: "Evening" },
                                                    { label: "Night", value: "Night" },
                                                    { label: "Rotational", value: "Rotational" }
                                                ]}
                                            // value={form.getFieldValue('shiftpreference')}
                                            // onChange={(value) => form.setFieldsValue({ shiftpreference: value })}
                                            />
                                        </div>

                                        <div>
                                            <DatePickerField
                                                label="Applied From Date"
                                                style={{ width: '100%' }}
                                                format="DD-MM-YYYY"
                                            // value={form.getFieldValue('appliedDateFrom')}
                                            // onChange={(date) => form.setFieldsValue({ appliedDateFrom: date })}
                                            />
                                        </div>

                                        <div>
                                            <DatePickerField
                                                label="Applied To Date"
                                                style={{ width: '100%' }}
                                                format="DD-MM-YYYY"
                                            // value={form.getFieldValue('appliedDateTo')}
                                            // onChange={(date) => form.setFieldsValue({ appliedDateTo: date })}
                                            />
                                        </div>

                                        <div style={{ marginBottom: '-10px' }}>
                                            <SelectInput
                                                label="Skills"
                                                name="skillTags"
                                                allowClear
                                                // mode="multiple"
                                                placeholder="Select Skills"
                                                style={{ width: "100%" }}
                                            // value={form.getFieldValue('skillTags')}
                                            // onChange={(value) => form.setFieldsValue({ skillTags: value })}
                                            // options={getOptionsByPath(NestedDatabucket, [RECRUITMENT, SKILL_TAGS])}
                                            />
                                        </div>

                                        <div style={{ marginBottom: '-20px' }}>
                                            <SelectInput
                                                label="Result"
                                                name="result"
                                                allowClear
                                                placeholder="Select Result"
                                                style={{ width: "100%" }}
                                                value={result}
                                                onChange={(value) => setResult(value)}
                                                options={[
                                                    { label: "Selected", value: "Selected" },
                                                    { label: "Hold", value: "Hold" },
                                                    { label: "Rejected", value: "Rejected" }
                                                ]}

                                            />
                                        </div>

                                        <div
                                            style={{
                                                marginBottom: '10px',
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                marginTop: 40,
                                            }}
                                        >
                                            <div style={{ display: 'flex', justifyContent: "center", width: "100%", gap: '8px', marginBottom: 10 }}>
                                                <AntdButton
                                                    type="primary"
                                                    onClick={handleSearch}
                                                    label="Search"
                                                />
                                                <AntdButton
                                                    onClick={onClear}
                                                    style={{ backgroundColor: '#6c757d', color: '#fff', border: 'none' }}
                                                    label="Clear"
                                                />
                                            </div>
                                        </div>
                                    </div>


                                </div>
                                <div className="right-frame">
                                    <div style={{ width: prevVisibility ? '81%' : '100%', marginLeft: prevVisibility && 'auto' }}>
                                        <div className="d-flex gap-2 justify-content-end" style={{ marginRight: '50px', marginBottom: "10px" }}>

                                            <Tooltip title="Sync Now">
                                                <FontAwesomeIcon
                                                    icon={faSync}
                                                    style={{
                                                        fontSize: '18px',
                                                        color: '#1890ff',
                                                        cursor: 'pointer',
                                                        margin: '8px'
                                                    }}
                                                    onClick={handleSync}
                                                />
                                            </Tooltip>

                                            <AntdButton
                                                label="Filters"
                                                color='primary'
                                                variant='solid'
                                                htmlType="submit"
                                                style={{ color: 'white' }}
                                                icon={<FontAwesomeIcon icon={faFilter} />}
                                                onClick={handleFilters}
                                            />
                                            <AntdButton label="Add Candidate" color='primary' variant='solid' htmlType="submit" style={{ color: "white" }} onClick={() => setOpen(true)} />

                                        </div>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="table-responsive">
                                                    <CustomGridTable
                                                        columns={columns}
                                                        dataSource={candidatesData}
                                                        pagination={{
                                                            showSizeChanger: true
                                                        }}
                                                        size="small"
                                                        scroll={{ x: false }}
                                                        onRow={(record) => ({
                                                            onClick: () => handleRowClick(record)
                                                        })}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                    </>
                }
            </div>
        </div>
    )
};

export default CandidateList;